import { FC } from 'react';

import { Icon } from './Icon';
import { SvgIcon } from './SvgIcon.type';

export const IconGallery: FC<SvgIcon> = (props) => (
  <Icon {...props} viewBox="0 0 20 20" name="gallery">
    <path d="M3.833 5c0-.644.522-1.167 1.167-1.167h9.666v-1H5c-1.197 0-2.167.97-2.167 2.167v9.667h1V5Z" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.916 11.667a2.083 2.083 0 1 0 0-4.167 2.083 2.083 0 0 0 0 4.167Zm0-1a1.083 1.083 0 1 0 0-2.167 1.083 1.083 0 0 0 0 2.167Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.5 5.333c-1.197 0-2.167.97-2.167 2.167V15c0 1.197.97 2.167 2.167 2.167H15c1.196 0 2.166-.97 2.166-2.167V7.5c0-1.197-.97-2.167-2.166-2.167H7.5ZM6.333 7.5c0-.644.522-1.167 1.167-1.167H15c.644 0 1.166.523 1.166 1.167v6.293l-1.646-1.647a.5.5 0 0 0-.707 0L12.5 13.46 8.687 9.646a.5.5 0 0 0-.708 0l-1.646 1.647V7.5Zm0 5.207V15c0 .644.522 1.167 1.167 1.167H15c.579 0 1.06-.422 1.15-.976l-1.984-1.984-1.313 1.313a.5.5 0 0 1-.707 0l-3.813-3.813-2 2Z"
    />
  </Icon>
);
